import { useState, useEffect } from 'react';
const useIsFirstMount = () => {
    const [isFirstMount, setIsFirstMount] = useState(true);
    useEffect(() => setIsFirstMount(false), []);
    return isFirstMount;
};
export default useIsFirstMount;
//# sourceMappingURL=index.js.map